import { useEffect, useState } from "react";

export const useGetWidgetWidth = (
	peadWidgetRef: React.RefObject<HTMLDivElement | null>,
): number => {
	const [widgetWidth, setWidgetWidth] = useState(0);

	// biome-ignore lint/correctness/useExhaustiveDependencies: we need peadWidgetRef.current to be the dependency
	useEffect(() => {
		let resizeTimeout: NodeJS.Timeout | null = null;
		setWidgetWidth(peadWidgetRef.current?.offsetWidth || 0);

		resizeTimeout = throttledResize(
			resizeTimeout,
			setWidgetWidth,
			peadWidgetRef,
		);

		const resizeObserver = new ResizeObserver(() => {
			resizeTimeout = throttledResize(
				resizeTimeout,
				setWidgetWidth,
				peadWidgetRef,
			);
		});

		if (peadWidgetRef.current) {
			resizeObserver.observe(peadWidgetRef.current);
		}

		return () => {
			if (resizeTimeout) clearTimeout(resizeTimeout);

			resizeObserver.disconnect();
		};
	}, [peadWidgetRef.current]);

	return widgetWidth;
};

export function throttledResize(
	resizeTimeout: NodeJS.Timeout | null,
	setWidgetWidth: (width: number) => void,
	peadWidgetRef: React.RefObject<HTMLDivElement | null>,
): NodeJS.Timeout {
	if (resizeTimeout) {
		clearTimeout(resizeTimeout);
	}

	const newTimeout = setTimeout(() => {
		setWidgetWidth(peadWidgetRef.current?.offsetWidth || 0);
	}, 300);

	return newTimeout;
}
